export enum EnumPolygonFillType {
  Solid = "solid",
  Cloropet = "cloropet"
}